// @flow
import {Grid, makeStyles} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import AboutUsSection from '../../../../my-store/customize/components/FormSections/AboutUsSection';
import {useForm} from 'react-hook-form';
import {useTypedSelector} from '../../../../../store';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {getImageUrl} from '../../../../../utils/image_provider';

import {actions} from '../../../../my-store/customize/duck';
import {useBindedActions} from '../../../../../utils/globalStore';
import LoadingSpinner from '../../../../../elements/LoadingSpinner/LoadingSpinner';
import SnackBar from '../../../../../elements/SnackBar/SnackBar';

type Props = {};

const useStyles = makeStyles(theme => ({
  card: {
    width: '100%',
  },
  saveBtnWrap: {
    display: 'flex',
    width: '100%',
    marginTop: theme.spacing(2),
    justifyContent: 'flex-end',
  },
  saveBtn: {
    width: '10rem',
  },
}));

function EditAboutUs(props: Props) {
  const classes = useStyles();
  const {register, setValue, errors, handleSubmit} = useForm();
  const saveStoreInformationSuccess = useTypedSelector(
    state => state.myStore.saveStoreInformationSuccess
  );
  const saveError = useTypedSelector(state => state.myStore.error);
  const isSaving = useTypedSelector(state => state.myStore.isSaving);
  const storeInformation = useTypedSelector(state => state.ui.storeInformation);

  const {saveStoreInformation} = useBindedActions(actions);

  const [isValidUrl, setIsValidUrl] = useState<boolean>(true);

  const [videoSocialMediaTypeId, setVideoSocialMediaTypeId] = useState();

  const [profileImage, setProfileImage] = useState<string | null>(null);
  const [profileImageFile, setProfileImageFile] = useState<File | null>(null);

  useEffect(() => {
    if (!storeInformation) return;
    if (storeInformation.profileInformation) {
      if (storeInformation.profileInformation.videoUrl) {
        setValue('videoUrl', storeInformation.profileInformation.videoUrl);
      }
      if (storeInformation.profileInformation.profilePhotoId) {
        setProfileImage(
          getImageUrl(storeInformation.profileInformation.profilePhotoId)
        );
      }
    }
  }, [setValue, storeInformation]);

  const handleSaveAboutUs = values => {
    const storeInformationRequest = {
      profileInformation: {
        description: values.description,
        profilePhotoId:
          storeInformation?.profileInformation?.profilePhotoId && !profileImage
            ? ''
            : undefined,
        videoSocialMediaTypeId:
          storeInformation?.profileInformation?.videoUrl === values.videoUrl
            ? undefined
            : videoSocialMediaTypeId,
        videoUrl:
          storeInformation?.profileInformation?.videoUrl === values.videoUrl
            ? undefined
            : values.videoUrl,
      },
      profileImageFile: profileImageFile ?? undefined,
    };

    saveStoreInformation({
      storeInformationRequest,
    });
  };

  return (
    <div className={classes.root}>
      {isSaving && <LoadingSpinner />}
      <SnackBar
        mode="success"
        message={saveStoreInformationSuccess ? 'Guardado correctamente' : ''}
      />
      <SnackBar mode="error" message={saveError ?? ''} />
      {/*      <Hidden smDown>
        <BackSectionButton
          to="/my-store/pages/home-page"
          label="Sección conócenos"
        />
      </Hidden> */}

      <Grid container>
        <Grid item xs={12}>
          <div className={classes.card}>
            <AboutUsSection
              storeInformation={storeInformation}
              setValue={setValue}
              errors={errors}
              register={register}
              setIsValidUrl={setIsValidUrl}
              isValidUrl={isValidUrl}
              profileImage={profileImage}
              setProfileImage={setProfileImage}
              setProfileImageFile={setProfileImageFile}
              setVideoSocialMediaTypeId={setVideoSocialMediaTypeId}
            />

            <div className={classes.saveBtnWrap}>
              <CustomButton
                className={classes.saveBtn}
                variant="contained"
                onClick={handleSubmit(handleSaveAboutUs)}
                disabled={isSaving}
              >
                Guardar
              </CustomButton>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default EditAboutUs;
